import { Tag } from "antd";

export const getRows = (t) => [
  {
    label: t('Product'),
    // render: () => <Tag color="gold">{t('Gold')}</Tag>,
    render: () => '--',
  },
  {
    label: t('Total Mercury Used'),
    // render: () => <label>4 kg</label>,
    render: () => '--',
  },
  {
    label: t('Total Mercury/1g Gold '),
    // render: () => <label>1.5g</label>,
    render: () => '--',
  },
]
